$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  EmailSignupFocus();
});

$(window).load(function () {
  contentMarginTop();
});

if (window.location.pathname === '/') {
  $(document).ready(function () {
    modifySignup();
  });
}

// Style Feature Button
function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  // if icons length + buttons length is greater than containerSize then add class "column" to buttonContainer
  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }

  // remove icons if there 0 children

  if (!icons.children().length) {
    icons.remove();
  }
}

function modifySignup() {
  const signupWidget = $('.tier-four .emailSignup');

  signupWidget.each(function () {
    const $this = $(this);
    const inputField = $this.find('.emailInputField');
    const submitButton = $this.find('.emailInputSubmit');

    $this.find('.emailSignupText').replaceWith(`
      <div class="emailSignupTextContainer">       
        <h3>Never miss out!</h3>
        <p>Don’t be left behind! Sign up for the latest National Peanut Festival updates!</p>     
      </div>`);

    $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');

    inputField
      .find('.inputFieldTextbox')
      .val('')
      .attr('placeholder', 'Email Address')
      .attr('aria-label', 'Email address');

    submitButton.find('.emailSubmitButton').text('subscribe');
  });
}

// Calculate content margin top
function contentMarginTop() {
  function updateContentMargin() {
    const headerHeight = $('header').outerHeight();
    const topHeaderHeight = $('.top-header').outerHeight();
    const generalMessageHeight = $('.generalmessage').outerHeight();

    if ($('body').hasClass('saffireWindowScrolled')) {
      $('header').css('top', -(topHeaderHeight + generalMessageHeight) + 'px');

      if ($('body').hasClass('homepage')) {
        $('.content').css(
          'margin-top',
          headerHeight - (topHeaderHeight + generalMessageHeight) + 'px',
        );
      } else {
        $('.content').css(
          'margin-top',
          headerHeight - (topHeaderHeight + generalMessageHeight) + 70 + 'px',
        );
      }
    } else {
      $('header').css('top', '0');

      if ($('body').hasClass('homepage')) {
        $('.content').css('margin-top', headerHeight + 'px');
      } else {
        $('.content').css('margin-top', headerHeight + 70 + 'px');
      }
    }
  }

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      updateContentMargin();
      clearInterval(interval);
    }
  }, 500);

  $(window).on('scroll', function () {
    updateContentMargin();
  });
}

function EmailSignupFocus() {
  $('.header .emailSignup').attr('tabindex', '0');
}
